export const GAME_CONSTANTS = {
  // Grid constraints
  MIN_GRID_SIZE: 5,
  MAX_GRID_SIZE: 20,
  DEFAULT_GRID_SIZE: 10,
  
  // Player limits
  MIN_PLAYERS: 1,
  MAX_PLAYERS: 8,
  DEFAULT_MAX_PLAYERS: 4,
  
  // Game timing
  DEFAULT_TIME_LIMIT: 300, // 5 minutes in seconds
  MIN_TIME_LIMIT: 60, // 1 minute
  MAX_TIME_LIMIT: 1800, // 30 minutes
  
  // Scoring
  POINTS_PER_CELL: 10,
  BONUS_POINTS_COMPLETION: 100,
  
  // Network
  RECONNECT_TIMEOUT: 30000, // 30 seconds
  HEARTBEAT_INTERVAL: 5000, // 5 seconds
} as const;



/** The colors players pick from in multiplayer (and accounts get by default). */
export const PLAYER_COLORS = [
  '#e53935', // red
  '#f57c00', // orange
  '#fbc02d', // yellow
  '#388e3c', // green
  '#1976d2', // blue
  '#7b1fa2', // purple
  '#00838f', // teal
  '#c2185b', // pink
] as const;

/** A player color picked from `seed` (an account id, say), the same every time. */
export function defaultPlayerColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return PLAYER_COLORS[hash % PLAYER_COLORS.length];
}

export enum CellValue {
  UNFILLED = -1,
  CROSSED = 0
}
// colyseus events

/**
 * The room protocol's version: an app and the server must agree on it.
 * Bump it whenever a room message, the room's state, or what one of their
 * fields means changes, so an app cached on a device from before is told to
 * update instead of misreading the room. (1: before the check existed;
 * 2: stable player ids; 3: multi-part puzzles, with a board per part.)
 */
export const ROOM_PROTOCOL_VERSION = 3

/** The code a room refuses a join with when the app's protocol isn't the server's; the message is the server's version. */
export const ROOM_PROTOCOL_MISMATCH = 4600

export const C2S_MSG_MOVE = "move"
export const C2S_MSG_CURSOR_UPDATE = "cursor_update"
export const C2S_MSG_START_PUZZLE = "start_puzzle"
export const C2S_MSG_ABORT_PUZZLE = "abort_puzzle"
export const C2S_MSG_UPDATE_PLAYER = "update_player_info"
/** Take back (or put back) the sender's own last move: cells others changed since stay. */
export const C2S_MSG_UNDO = "undo"
export const C2S_MSG_REDO = "redo"
/** Which part of a multi-part puzzle the sender is in (its index; -1: the picture). */
export const C2S_MSG_SELECT_PART = "select_part"
/** Host only: a change to the room's settings (`Partial<RoomSettings>`). */
export const C2S_MSG_UPDATE_SETTINGS = "update_settings"

// Server to client events

export const S2C_MSG_CURSOR_UPDATE = "cursor_update"
export const S2C_MSG_MOVE = "move"
export const S2C_MSG_PUZZLE_COMPLETE = "puzzle_completed"

/** The tag on puzzles players shared by link; each has a board of who solved it. */
export const SHARED_PUZZLE_TAG = 'shared';

/** A puzzle shared by link: it has a board of who solved it. */
export function isSharedPuzzle(puzzle: { tags: readonly string[] }): boolean {
  return puzzle.tags.includes(SHARED_PUZZLE_TAG);
}

/** Longest name (and author) a player-made puzzle can have; the editor and server agree. */
export const PUZZLE_NAME_MAX_LENGTH = 80;
export const PUZZLE_AUTHOR_MAX_LENGTH = 40;
